<script>
export default {
  props: {
    onReportMenuClick: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
